import {
  Button,
  Layout,
  Input,
  Typography,
  Collapse,
  Form,
  message,
  Empty,
  Tooltip,
  AutoComplete,
  Tag,
  List,
  Tabs,
} from "antd";

import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Scrollbar } from "react-scrollbars-custom";

import React, { useEffect, useRef, useState } from "react";
import {
  allDiaries,
  arciveDiaries,
  currentDiaryDetail,
  currentDiaryTopic,
  diaryStatus,
  fetchAllArchiveDiaries,
  fetchDiaryEntries,
  globalSearchData,
  hideClassName,
  notificationFlag,
  saveAllArchiveDiaries,
  saveAllDiaries,
  saveArchiveModalOpen,
  saveCurrentDiary,
  saveCurrentDiaryDetail,
  saveDiaryStatus,
  saveEntriesLoader,
  saveFromNotificationFlag,
  saveFromSearchFlag,
  saveGlobalSearchedData,
  saveHideClassName,
  saveSearchEntryId,
  saveUnArchiveModalOpen,
} from "redux/diaries/diariesSlice";
import { useDispatch, useSelector } from "react-redux";
import NetworkCall from "network/networkCall";
import Request from "network/request";
import { leadingSpaces } from "utilities/regexUtilities";
import StartDiaryModal from "features/myDiaries/modals/startDiaryModal";
import UserFeedback from "../../features/userFeedback/userFeedback";
import User from "models/user/user";
import { InView, useInView } from "react-intersection-observer";
import {
  DiaryStatusRoutes,
  calculateTimeRemaining,
  convertoUSFormatOnlyDate,
  downloadEvent,
} from "utilities/generalUtility";
import moment from "moment";
import { globalSettings } from "redux/settings/settingSlice";

const { Text, Title } = Typography;
const { Sider } = Layout;
const { Panel } = Collapse;
const { Search } = Input;
const { Option } = AutoComplete;

export default function DiaristHabitSider() {
  const [searchParam, setSearchParam] = useSearchParams();

  const dispatch = useDispatch();
  const diaries = useSelector(allDiaries);
  const archiveDiaries = useSelector(arciveDiaries);
  const [selectedTab, setselectedTab] = useState(
    searchParam.get("archived") ? "2" : "1"
  );
  const [showInput, setShowInput] = useState(null);
  const [form] = Form.useForm();
  const diaryDetail = useSelector(currentDiaryDetail);

  const [btnLoading, setbtnLoading] = useState(false);
  const [selectedTopicId, setSelectedTopicId] = useState(null);
  const [activeKey, setActiveKey] = useState(null); // Set the default active key
  const [searchValue, setsearchValue] = useState(null);
  const currStatus = useSelector(diaryStatus);
  const selected = useSelector(currentDiaryTopic);
  const NotificationFlag = useSelector(notificationFlag);
  const scrollableDivRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const inputRef = useRef(null);
  const hideClass = useSelector(hideClassName);
  const viewportWidth = window.innerWidth;
  const [debounce, setdebounce] = useState();
  const [searchStart, setsearchStart] = useState(false);
  const globalSearch = useSelector(globalSearchData);
  const settings = useSelector(globalSettings);
  const options = {
    root: document.querySelector(".card-scroll"),
    rootMargin: "0px",
    threshold: 1.0,
  };
  const { ref, inView } = useInView(options);
  const [hasMoreSearchedResults, sethasMoreSearchedResults] = useState(false);
  const [hasArchive, sethasArchive] = useState(false); // if is there any archive journal then make it true
  //Topics
  const [allTopics, setAllTopics] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [topicId, setTopicId] = useState();

  //Functions

  const handleSelectedDiaryTopic = (
    diaryId,
    topicId,
    topicName,
    flag = false,
    searchFlag = false,
    archiveFlag = false
  ) => {
    if (selectedTopicId !== topicId || topicId === null) {
      dispatch(saveCurrentDiary({ diaryId, topicId, topicName }));
      const params = `?diaryId=${diaryId}&diaryTopicId=${topicId}`;

      if (diaryId && topicId) {
        if (!searchFlag) {
          setSearchParam(params);
        } else {
          navigate(`/${params}`);
        }
      }
    }
    if (topicId && !flag) {
      const temp = archiveFlag
        ? [...archiveDiaries]
        : selectedTab === "1"
        ? [...diaries]
        : [...archiveDiaries];
      const index = temp?.findIndex((e) => e?.diaryId === diaryId);
      const tempTopics = [...temp[index]?.topics];

      const topicIndex = tempTopics.findIndex((e) => e?.id === topicId);
      const count = tempTopics[topicIndex]?.unseenMessageCount;
      tempTopics[topicIndex] = {
        ...tempTopics[topicIndex],
        unseenMessageCount: 0,
      };
      temp[index] = {
        ...temp[index],
        topics: [...tempTopics],
        totalUnseenMessageCountInDiary:
          temp[index]?.totalUnseenMessageCountInDiary - count,
      };
      dispatch(
        archiveFlag
          ? saveAllArchiveDiaries(temp)
          : selectedTab === "1"
          ? saveAllDiaries(temp)
          : saveAllArchiveDiaries(temp)
      );
    }
    if (viewportWidth < 700 && topicId) {
      dispatch(saveHideClassName("sider-none"));
    }
    if (location.pathname === "/resolveit-search") {
      navigate("/");
    }
  };

  const addTopic = async (id) => {
    let response;
    try {
      if (topicId) {
        const body = {
          diaryId: id,
          topicId: parseInt(topicId),
        };
        setbtnLoading(true);
        response = await NetworkCall.fetch(
          Request.addGlobalTopicToDiary(body),
          false
        );
      } else {
        const body = {
          type: 1,
          diaryId: id,
          name: form.getFieldValue("topic"),
        };
        setbtnLoading(true);
        response = await NetworkCall.fetch(Request.AddType(body), false);
      }
      message.success(response?.message);
      let temp = [...diaries];
      const index = temp?.findIndex((e) => e?.diaryId === id);
      response.data.lastEntryTimestamp = null;
      response.data.lastEntrySenderId = null;
      response.data.numberOfDrafts = 0;
      response.data.unseenMessageCount = 0;
      temp[index] = {
        ...temp[index],
        topics: [response?.data, ...temp[index]?.topics],
      };
      dispatch(saveAllDiaries(temp));
      dispatch(saveDiaryStatus({ diary: temp[index] }));
      let diary = {
        ...diaryDetail,
        topics: [response?.data, ...diaryDetail?.topics],
      };

      dispatch(saveCurrentDiaryDetail(diary));
      setbtnLoading(false);
      setShowInput(null);
      form.setFieldsValue({ topic: null });
      handleSelectedDiaryTopic(
        id,
        response?.data?.id,
        response?.data?.name,
        true
      );
    } catch (error) {
      setbtnLoading(false);
      message.error(error?.message);
    }
  };

  const showHideInput = (index) => {
    setShowInput(index);
    form.setFieldsValue({ topic: null });
  };

  const hasDrafted = (topics) => {
    const totalDraftedCount = topics.reduce((accumulator, topic) => {
      return accumulator + topic.numberOfDrafts;
    }, 0);

    return totalDraftedCount > 0;
  };

  const handlePanel = (diary) => {
    if (currStatus?.diary?.diaryId !== diary?.diaryId) {
      dispatch(saveFromSearchFlag(false));

      dispatch(saveDiaryStatus({ diary }));
      if (diary?.topics.length > 0 && viewportWidth >= 700) {
        handleSelectedDiaryTopic(
          diary?.diaryId,
          diary?.topics[0]?.id,
          diary?.topics[0]?.name
        );
      } else {
        handleSelectedDiaryTopic(null, null, null);
      }
      const params = `?diaryId=${diary?.diaryId}&diaryTopicId=${diary?.topics[0]?.id}`;
      navigate(
        `${DiaryStatusRoutes[diary?.status?.id] ?? "/journal-request"}${params}`
      );
    }
  };

  const handleSearch = (event) => {
    setsearchValue(event.target.value);
    event.target.value === "" && setsearchStart(false);
  };

  const getAllGlobalTopics = async () => {
    const data = await User.getAllTopics();
    setAllTopics(data?.data?.tableListing);
  };

  const onSearch = (value) => {
    const filteredTopics = allTopics.filter((topic) =>
      topic?.name?.toLowerCase().includes(value?.toLowerCase())
    );
    setSuggestions(filteredTopics);
  };

  const onSelect = (value, option) => {
    setTopicId(option.key);
  };

  const isDraftAvailableInLocal = (id) => {
    const getData = localStorage.getItem(id);
    return getData === "null" || !getData ? false : true;
  };

  const redirection = (diaryId, diaryTopicId) => {
    if (diaryId) {
      const check = diaries?.findIndex((e) => e?.diaryId === parseInt(diaryId));
      const flag = check === -1;
      const clone = flag ? [...archiveDiaries] : [...diaries];
      const index = clone?.findIndex((e) => e?.diaryId === parseInt(diaryId));

      const topicIndex = diaryTopicId
        ? clone[index]?.topics?.findIndex(
            (e) => e?.id === parseInt(diaryTopicId)
          )
        : 0;
      dispatch(saveDiaryStatus({ diary: clone[index] }));
      handleSelectedDiaryTopic(
        parseInt(diaryId),
        clone[index]?.topics[topicIndex]?.id,
        clone[index]?.topics[topicIndex]?.name,
        null,
        null,
        check === -1
      );
      const params = `?diaryId=${diaryId}&diaryTopicId=${diaryTopicId}`;

      navigate(
        `${
          DiaryStatusRoutes[clone[index]?.status?.id] ?? "/journal-request"
        }${params}`
      );
      check === -1 && setselectedTab("2");
    } else {
      if (searchParam.get("archived")) {
        const params = `?archived=true`;
        navigate(`/journal-request${params}`);
      } else {
        navigate("/journal-request");
      }
      dispatch(saveDiaryStatus({}));
      handleSelectedDiaryTopic(null, null, null);
    }
  };

  const globalSearchApiCall = async (value, inview) => {
    try {
      inView === undefined && saveGlobalSearchedData({});
      const body = {
        searchString: value,
        globalSearchType: inview ? 2 : 1,
        entriesSearch: {
          pageNumber: 1,
          pageSize: 10,
          releasedEntryId: inview
            ? globalSearch?.entries[globalSearch?.entries?.length - 1]
                ?.releasedEntryId
            : null,
        },
      };
      const res = await NetworkCall.fetch(Request.globalSearch(body), false);
      if (res?.data?.entries?.data && res?.data?.entries?.data?.length > 0) {
        sethasMoreSearchedResults(true);
      } else {
        sethasMoreSearchedResults(false);
      }

      if (inview) {
        if (res?.data?.entries?.data) {
          let record = { ...globalSearch };
          record = {
            ...record,
            entries: [...record?.entries, ...res?.data?.entries?.data],
          };
          dispatch(saveGlobalSearchedData(record));
        }
      } else {
        dispatch(
          saveGlobalSearchedData({
            diaries: res?.data?.diaries,
            diaryTopics: res?.data?.diaryTopics,
            entries: res?.data?.entries?.data
              ? res?.data?.entries?.data
              : res?.data?.entries,
          })
        );
      }

      setsearchStart(true);
    } catch (error) {}
  };

  const searchTopicSelected = (data) => {
    dispatch(saveFromSearchFlag(false));

    redirection(data?.diaryId, data?.diaryTopicId);
  };

  const searchMessageSelected = (element) => {
    const body = {
      pageNumber: 0,
      pageSize: 10,
      searchType: 1,
      diaryId: element?.diaryId,
      diaryTopicIds: [element?.diaryTopicId],
      diaryEntryId: null,
      releasedEntryId: element?.releasedEntryId,
      direction: 3,
    };
    dispatch(saveEntriesLoader(true));
    dispatch(saveFromSearchFlag(true));
    dispatch(saveSearchEntryId(element?.diaryEntryId));
    dispatch(fetchDiaryEntries(body, false));

    const index = diaries?.findIndex((e) => e?.diaryId === element?.diaryId);
    dispatch(saveDiaryStatus({ diary: diaries[index] }));
    handleSelectedDiaryTopic(
      element?.diaryId,
      element?.diaryTopicId,
      element?.topicName,
      false,
      true
    );
  };
  const getArchiveTopic = () => {
    dispatch(fetchAllArchiveDiaries());
  };

  // UseEffects
  useEffect(() => {
    getAllGlobalTopics();
    getArchiveTopic();
    if (!NotificationFlag) {
      diaries.length > 0 &&
        redirection(
          searchParam.get("diaryId"),
          searchParam.get("diaryTopicId")
        );
    } else {
      dispatch(saveFromNotificationFlag(false));
    }
  }, []);

  useEffect(() => {
    setShowInput(null);
  }, [activeKey]);

  useEffect(() => {
    setActiveKey(currStatus?.diary?.diaryId);

    searchParam.get("archivedNotification") !== null &&
      setselectedTab(
        searchParam.get("archivedNotification") === "true" ? "2" : "1"
      );
  }, [currStatus]);

  useEffect(() => {
    setSelectedTopicId(selected?.topicId);
  }, [selected]);

  useEffect(() => {
    // Scroll and highlight logic
    if (notificationFlag) {
      const commentElement = document.getElementById(
        `panel-${selected?.diaryId}`
      );
      if (commentElement && scrollableDivRef.current) {
        commentElement.scrollIntoView();
        // You can add highlighting logic here
      }
    }
  }, []);

  // For setting focus

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [showInput]);

  // These are for debouncing the search call
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setdebounce(searchValue);
    }, 700);
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchValue]);

  useEffect(() => {
    if (debounce && debounce !== "") {
      globalSearchApiCall(debounce);
    }
  }, [debounce]);

  const collapseheader = (name, tag, status, topics, id) => (
    <>
      <Text className="collapse-wrapper">
        <div className="name-wrap">
          <Text className="collapse-name">
            {name}
            {(status === 3 || status === 6 || status === 7) && (
              <Text className="collapse-status">
                {status === 3
                  ? "Pending"
                  : status === 6
                  ? "Pending Archive"
                  : "Pending Unarchive"}
              </Text>
            )}
            {hasDrafted(topics) && (
              <Text className="collapse-draft">Draft</Text>
            )}
          </Text>
        </div>
        <div className="archive-panel-icon">
          {tag > 0 && <Text className="number-tag">{tag}</Text>}
          {status === 1 && id === activeKey && (
            <Tooltip title={"Archive a Journal"}>
              <i
                className="icon-archive-down"
                onClick={(e) => {
                  dispatch(saveArchiveModalOpen({ flag: true, diaryId: id }));
                  e.stopPropagation();
                  e.preventDefault();
                }}
              ></i>
            </Tooltip>
          )}
          {status === 5 && id === activeKey && (
            <Tooltip title={"Unarchive a Journal"}>
              <i
                className="icon-archive-up"
                onClick={(e) => {
                  dispatch(
                    saveUnArchiveModalOpen({
                      flag: true,
                      diaryId: id,
                      name: name,
                    })
                  );
                  e.stopPropagation();
                  e.preventDefault();
                }}
              ></i>
            </Tooltip>
          )}
        </div>
      </Text>
    </>
  );

  const highlightedString = (text) => {
    const searchValueLower = searchValue.toLowerCase();
    const parts = text.split(new RegExp(`(${searchValueLower})`, "gi"));

    const modifiedContent = parts.map((part, index) =>
      part.toLowerCase() === searchValueLower ? (
        <React.Fragment key={index}>
          <span className="highlighted">{part}</span>
        </React.Fragment>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      )
    );

    return modifiedContent;
  };
  const items = [
    {
      key: "1",
      label: `Active`,
    },
    {
      key: "2",
      label: `Archived`,
    },
  ];
  const onChange = (key) => {
    setselectedTab(key);
    if (key === "1") {
      navigate(`/journal-request`);
    } else {
      const params = `?archived=true`;
      navigate(`/journal-request${params}`);
    }
    dispatch(saveDiaryStatus({}));
    handleSelectedDiaryTopic(null, null, null);
  };

  return (
    <>
      <Sider
        breakpoint="lg"
        collapsible
        width={300}
        trigger={null}
        className={`dairist-sider ${hideClass}`}
        id="sider"
      >
        <div className="resolveit-sider-header">
          <StartDiaryModal />
          <Tabs
            className="sider-tabs"
            // defaultActiveKey="1"
            items={items}
            onChange={onChange}
            activeKey={selectedTab}
          />

          <div className="resolveit-filter">
            <Search
              value={searchValue}
              className="arrow-search"
              size="large"
              placeholder="SEARCH"
              prefix={
                searchStart ? (
                  <i
                    className={"icon-left-arrow-sqaure"}
                    onClick={() => {
                      setsearchValue("");
                      setsearchStart(false);
                    }}
                  ></i>
                ) : (
                  <i className={"icon-search"}></i>
                )
              }
              onChange={handleSearch}
            />
          </div>
        </div>
        <Scrollbar className="sider-collapse-scrollbar" ref={scrollableDivRef}>
          {searchStart && globalSearch?.diaries.length > 0 && (
            <Title className="sider-title" level={5}>
              Journals
            </Title>
          )}
          {hasArchive && (
            <div className="collabe-sider-header">
              <i class="icon-archive-down"></i>
              <p>View Archived Journals</p>
            </div>
          )}
          <Collapse
            className="sider-collapse"
            activeKey={activeKey}
            expandIconPosition="end"
            bordered={false}
            expandIcon={({ isActive }) =>
              !isActive && <i className="icon-chevron-down" />
            }
          >
            {(selectedTab === "1" ? diaries : archiveDiaries).length > 0 ? (
              searchStart &&
              globalSearch?.diaries?.length === 0 &&
              globalSearch?.diaryTopics?.length === 0 &&
              globalSearch?.entries?.length === 0 ? (
                <div className="empty-wrapper">
                  <Empty
                    className="sider-empty"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={"No Result"}
                  />
                </div>
              ) : (
                (searchStart
                  ? globalSearch?.diaries
                  : selectedTab === "1"
                  ? diaries
                  : archiveDiaries
                )?.map((element, index) => {
                  return (
                    <Panel
                      id={`panel-${element?.diaryId}`}
                      header={collapseheader(
                        element?.userName,
                        element?.totalUnseenMessageCountInDiary,
                        element?.status?.id,
                        element?.topics,
                        element?.diaryId
                      )}
                      key={element?.diaryId}
                      onClick={(e) => {
                        handlePanel(element);
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <ul className="topic-list list-unstyled">
                        {element?.topics.map((topics) => {
                          return (
                            <li
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                handleSelectedDiaryTopic(
                                  element?.diaryId,
                                  topics?.id,
                                  topics?.name
                                );
                                dispatch(saveFromSearchFlag(false));

                                e.stopPropagation();
                              }}
                            >
                              {/* <i class="icon-unlock"></i> */}
                              {/* <i class="icon-lock"></i> */}

                              {topics?.lastEntryTimestamp === null ? (
                                <i class="icon-unlock"></i>
                              ) : calculateTimeRemaining(
                                  topics?.lastEntryTimestamp,
                                  parseInt(settings?.LockPeriod)
                                ) === null ? (
                                <i class="icon-unlock"></i>
                              ) : calculateTimeRemaining(
                                  topics?.lastEntryTimestamp,
                                  parseInt(settings?.GracePeriod)
                                ) === null ? (
                                topics?.lastEntrySenderId ===
                                User.getUserId() ? (
                                  <i class="icon-locked"></i>
                                ) : (
                                  <i class="icon-unlock"></i>
                                )
                              ) : (
                                <i class="icon-locked"></i>
                              )}
                              <div
                                key={topics?.id}
                                level={5}
                                className={
                                  topics?.id === selectedTopicId
                                    ? "status-listing active mt-0"
                                    : "status-listing draft-text mt-0"
                                }
                              >
                                <Tooltip title={topics?.name} placement="right">
                                  <div className="name-status">
                                    <span className="name">{topics?.name}</span>
                                    {topics?.unseenMessageCount > 0 && (
                                      <div className="status-circle"></div>
                                    )}
                                  </div>
                                </Tooltip>
                                {(topics?.numberOfDrafts > 0 ||
                                  isDraftAvailableInLocal(
                                    topics?.id,
                                    element?.userName
                                  )) && <Tag className="draft-tag">Draft</Tag>}
                              </div>
                            </li>
                          );
                        })}
                      </ul>
                      {index === showInput ? (
                        <>
                          <Form
                            form={form}
                            onFinish={(e) => {
                              addTopic(element?.diaryId);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                          >
                            <Form.Item
                              name="topic"
                              className="new-topic-field mb-1"
                              rules={[
                                {
                                  required: true,
                                  message: "Name is required",
                                },
                                {
                                  pattern: new RegExp(leadingSpaces),
                                  message:
                                    "Topics must have 5 characters and does not accept leading spaces",
                                },
                                {
                                  type: "string",
                                  max: 45,
                                  message:
                                    "Topic Name cannot be longer than 45 characters",
                                },
                              ]}
                            >
                              <AutoComplete
                                defaultOpen
                                onFocus={() => {
                                  setSuggestions(allTopics);
                                }}
                                ref={inputRef}
                                size="small"
                                placeholder="Enter Topic Name"
                                onSearch={onSearch}
                                onSelect={onSelect}
                                onChange={() => setTopicId(null)}
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                                getPopupContainer={(triggerNode) => {
                                  return triggerNode.parentNode;
                                }}
                              >
                                {suggestions.map((topic) => (
                                  <Option
                                    key={topic.topicId}
                                    value={topic.name}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                    }}
                                  >
                                    {topic.name}
                                  </Option>
                                ))}
                              </AutoComplete>
                            </Form.Item>
                            <Form.Item className="mb-0">
                              <Button
                                className="btn-topics"
                                key="add"
                                htmlType="submit"
                                loading={btnLoading}
                                onClick={(e) => {
                                  form.submit();
                                  downloadEvent("AddTopic");
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                              >
                                Save
                              </Button>
                            </Form.Item>
                          </Form>
                        </>
                      ) : (
                        <Tooltip
                          title={
                            element?.status?.id === 1
                              ? ""
                              : element?.status?.id === 6 ||
                                element?.status?.id === 7
                              ? "Journal status is Pending"
                              : `Journal status is ${element?.status?.name}`
                          }
                          placement="right"
                        >
                          <Button
                            size="middle"
                            className="btn-topics btn-disable"
                            onClick={(e) => {
                              showHideInput(index);
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            disabled={!(element?.status?.id === 1)}
                          >
                            Add New Topic
                          </Button>
                        </Tooltip>
                      )}
                    </Panel>
                  );
                })
              )
            ) : (
              <div className="empty-wrapper">
                <Empty
                  className="sider-empty"
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    diaries.length > 0 ? "No Result" : "No Journal Yet"
                  }
                />
              </div>
            )}
          </Collapse>
          {searchStart && (
            <>
              {globalSearch?.diaryTopics.length > 0 && (
                <>
                  {" "}
                  <Title className="sider-title" level={5}>
                    Topics
                  </Title>
                  <List
                    className="sider-list"
                    itemLayout="horizontal"
                    dataSource={globalSearch?.diaryTopics}
                    renderItem={(item) => (
                      <List.Item onClick={() => searchTopicSelected(item)}>
                        <List.Item.Meta
                          title={item?.userName}
                          description={<>{highlightedString(item?.name)}</>}
                        />
                      </List.Item>
                    )}
                  />
                </>
              )}
              {globalSearch?.entries && globalSearch?.entries?.length > 0 && (
                <>
                  {" "}
                  <Title className="sider-title" level={5}>
                    Message
                  </Title>
                  <List
                    className="sider-list"
                    itemLayout="horizontal"
                    dataSource={globalSearch?.entries}
                    renderItem={(item) => (
                      <List.Item onClick={() => searchMessageSelected(item)}>
                        <List.Item.Meta
                          title={
                            <>
                              {item?.coDiaristUserName}{" "}
                              <span className="date">
                                {convertoUSFormatOnlyDate(
                                  moment,
                                  item?.createdAt
                                )}
                              </span>
                            </>
                          }
                          description={<>{highlightedString(item?.text)}</>}
                        />
                      </List.Item>
                    )}
                  />
                </>
              )}
            </>
          )}
          <InView
            rootMargin="20px"
            skip={!searchStart}
            onChange={(inView, entry) => {
              inView &&
                hasMoreSearchedResults &&
                globalSearchApiCall(debounce, inView);
            }}
          >
            <div ref={ref} id="bottom" style={{ visibility: "hidden" }}>
              <>{`Header inside viewport ${inView}.`}</>
            </div>
          </InView>
        </Scrollbar>
        <UserFeedback />
      </Sider>
    </>
  );
}
